var _ = require('../utils/lib.js');
var Option = require('./option.js');

var Options = function (giftProducts, lineItems) {
  this.items = [];
  this.giftProductType = 'Gift Option';
  this.giftProducts = giftProducts;

  giftOptions.productTypeBlacklist = giftOptions.productTypeBlacklist || [];
  giftOptions.productTypeBlacklist.push(this.giftProductType);
  this.line_items = this._removeGiftLineItems(lineItems);

  Object.defineProperty(this, 'size', {
    get: function () {
      return this.items.length;
    }
  });

  Object.defineProperty(this, 'valid', {
    get: function () {
      return this._validate();
    }
  });
};

Options.prototype.createGiftOption = function () {
  var option = new Option(this.giftProducts);
  this.items.push(option);
};

Options.prototype.removeGiftOption = function (optionID) {
  var item = this._getOptionByID(optionID);
  this.removeAllLineItemsFromGiftOption(item);
  var itemIndex = this.items.indexOf(item);
  this.items.splice(itemIndex, 1);
};

Options.prototype.addGiftOptionProduct = function (optionData) {
  var item = this._getOptionByID(optionData.id);
  item.giftOptionSelected(optionData);
};

Options.prototype.updateGiftOptionProductMessage = function (optionData) {
  var item = this._getOptionByID(optionData.id);
  item.giftOptionMessage(optionData);
};

Options.prototype.setGiftOptionProductVariant = function (optionData) {
  var item = this._getOptionByID(optionData.id);
  item.setSelectedVariant(optionData);
};

Options.prototype.addLineItemToGiftOption = function (optionData) {
  var item = this._getOptionByID(optionData.id);
  var lineItem = this._getLineItemByID(optionData.lineItemID);
  item.addLineItem(lineItem);

  // remove the line item from the options list now it's added to an option
  var lineItemIndex = this.line_items.indexOf(lineItem);
  lineItem = this.line_items.splice(lineItemIndex, 1);
};

Options.prototype.removeLineItemFromGiftOption = function (optionData) {
  var item = this._getOptionByID(optionData.id);
  var lineItem = item.removeLineItem(optionData.lineItemID);
  this.line_items.push(lineItem);
};

Options.prototype.removeAllLineItemsFromGiftOption = function (item) {
  if (typeof item == 'string') {
    item = this._getOptionByID(optionID);
  }
  var _this = this;
  _.each(item.line_items, function (line_item) {
    var lineItem = item.removeLineItem(line_item);
    _this.line_items.push(lineItem);
  });
};

// Private
Options.prototype._validate = function () {
  var valid = false,
    validCount = 0;
  _.each(this.items, function (item) {
    if (item.valid) {
      validCount++;
    }
  });
  if (this.items.length > 0 && this.items.length == validCount) {
    valid = true;
  }
  return valid;
};

Options.prototype._removeGiftLineItems = function (lineItems) {
  var newLineItems = [];
  _.each(lineItems, function (lineItem) {
    if (!this._isBlacklistProduct(lineItem)) {
      newLineItems.push(lineItem);
    }
  }, this);
  return newLineItems;
};

Options.prototype._isBlacklistProduct = function (product) {
  return _.inArray((product.type || product.product_type), giftOptions.productTypeBlacklist);
};

Options.prototype._getOptionByID = function (id) {
  return this._getByID(this.items, id);
};

Options.prototype._getLineItemByID = function (id) {
  return this._getByID(this.line_items, id, 'key');
};

Options.prototype._getByID = function (arr, id, key) {
  var found;
  key = key || 'id';
  _.each(arr, function (item) {
    if (item[key] == id) {
      found = item;
    }
  });
  return found;
};

module.exports = Options;
